export const KPI_UNIT = {
  currency: 'currency',
  percent: 'percent',
  count: 'count',
};
